import { getActivePinia } from 'pinia'

/**
 * Reset all stores in the active Pinia instance
 */
export function useResetPinia() {
  const pinia = getActivePinia()

  if (!pinia) {
    throw new Error('There is no active Pinia instance.')
  }

  const resetStore = {}

  pinia._s.forEach((store, name) => {
    resetStore[name] = () => store.$reset()
  })

  resetStore.all = () => pinia._s.forEach(store => store.$reset())

  return resetStore
}

/**
 * Resets a Vue reactive object by removing all its properties and optionally restoring its initial state.
 *
 * This function iterates over all keys in the provided reactive object and deletes them. If an initial
 * object is provided and is a valid object, its properties are assigned to the reactive object,
 * preserving the original reactive reference.
 *
 * @param {object} obj - The reactive object to reset.
 * @param {object | null} [initial] - An optional object with initial values to restore. If null or not an object,
 *                                  the reactive object will remain empty after reset.
 * @returns {void}
 */
export function resetReactiveObject(obj, initial) {
  Object.keys(obj).forEach((key) => {
    delete obj[key]
  })

  if (initial !== null && typeof initial === 'object') {
    Object.assign(obj, initial)
  }
}
